import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: true,
  data: {},
  authenticated: false,
})

const { Types, Creators } = createActions({
  login: ['credential'],

  setLoginLoading: ['val'],

  setAuthData: ['data'],
  setAuthField: ['key', 'value'],

  setAuthenticated: ['status'],
  handleAuthSuccess: ['uid'],
  logout: null,
})

export const loginReducer = state => state.set('loading', true)

export const setLoginLoadingReducer = (state, { val }) => state.set('loading', val)

export const setAuthDataReducer = (state, { data }) => state.set('data', data)

export const setAuthenticatedReducer = (state, { status }) =>
  state.set('authenticated', status).set('loading', false)

export const setAuthFieldReducer = (state, { key, value }) =>
  state.setIn(['data', key], value)

export const authReducer = createReducer(INITIAL_STATE, {
  [Types.LOGIN]: loginReducer,

  [Types.SET_LOGIN_LOADING]: setLoginLoadingReducer,
  [Types.SET_AUTH_DATA]: setAuthDataReducer,

  [Types.SET_AUTHENTICATED]: setAuthenticatedReducer,
  [Types.SET_AUTH_FIELD]: setAuthFieldReducer,
})

export const AuthTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js